import { StyleSheet, type TextStyle } from 'react-native';
import theme from '../../../common/theme';

const textStyle: TextStyle = {
  fontSize: 14,
  lineHeight: 20,
  fontFamily: theme.fonts.medium,
  color: theme.palette.mono800,
};

export const styles = StyleSheet.create({
  container: {
    width: 600,
    alignSelf: 'center',
  },
  content: {
    padding: 30,
    paddingTop: 14,
    marginTop: 8,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.white,
    ...theme.shadow.strong,
  },
  scroll: {
    maxHeight: 460,
  },
  contentRow: {
    marginTop: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  contentTitle: {
    ...textStyle,
    flex: 1,
    color: theme.palette.mono500,
  },
  contentValue: {
    ...textStyle,
    maxWidth: '60%',
    textAlign: 'right',
    fontFamily: theme.fonts.regular,
  },
  contentValueError: {
    color: theme.palette.red,
  },
  sectionTitle: {
    ...textStyle,
    marginTop: 24,
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: theme.palette.mono500,
  },
  banner: {
    padding: 12,
    marginTop: 16,
    borderRadius: theme.radius.s,
  },
  bannerPositive: {
    backgroundColor: theme.palette.greenLightest,
  },
  bannerNegative: {
    backgroundColor: theme.palette.redLightest,
  },
  bannerNeutral: {
    backgroundColor: theme.palette.mono100,
  },
  action: {
    marginTop: 12,
  },
  bannerText: {
    ...textStyle,
  },
  issue: {
    padding: 12,
    marginTop: 12,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.mono100,
  },
  issueCode: {
    ...textStyle,
    color: theme.palette.red,
  },
  issueText: {
    ...textStyle,
    marginTop: 4,
    color: theme.palette.mono500,
    fontFamily: theme.fonts.regular,
  },
  issueAction: {
    ...textStyle,
    marginTop: 4,
  },
  raw: {
    ...textStyle,
    padding: 12,
    marginTop: 12,
    fontSize: 11,
    lineHeight: 16,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.mono100,
    color: theme.palette.mono500,
    fontFamily: theme.fonts.regular,
  },
});
